import { Examples } from '@/types';

export const ExampleReferenceToggleModalRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleReferenceToggleModal,
        components: {
          default: () => import(/* webpackChunkName: "ExampleReferenceToggleModal" */
            '@/views/examples/ExampleReferenceToggleModal.vue')
        }
      }
    ]
    : [];